export function fullName(object) {
  const texts = [];

  if (object) {
    if (object.first_name) {
      texts.push(object.first_name);
    }

    if (object.last_name) {
      texts.push(object.last_name);
    }
  }

  return texts.join(' ');
}

export function shortTitle(title, maxLength = 30) {
  if (title.length >= maxLength) {
    return title.substr(0, maxLength - 1).concat('...');
  }

  return title;
}

export function escapeSpecialChars(data) {
  if (typeof data === 'string') {
    return data.replace(/\\/g, '\\\\').trim();
  }
  return data;
}
